import axios from 'axios'

import {
    HOMEPAGE_DATA_REQUEST,
    HOMEPAGE_DATA_REQUEST_SUCCESS,
    HOMEPAGE_DATA_REQUEST_FAIL,
    ABOUT_DATA_REQUEST,
    ABOUT_DATA_REQUEST_SUCCESS,
    ABOUT_DATA_REQUEST_FAIL,
    CONTACT_DATA_REQUEST,
    CONTACT_DATA_REQUEST_SUCCESS,
    CONTACT_DATA_REQUEST_FAIL,
    CONTACT_REQUEST,
    CONTACT_REQUEST_SUCCESS,
    CONTACT_REQUEST_FAIL
} from './pageConstants'

export const homePageData = (lang) => async (dispatch) => {
    try {
        dispatch({ type: HOMEPAGE_DATA_REQUEST })
        const { data } = await axios.get('/api/home?lan=' + lang)
        if (data.status === "ok") {
            dispatch({
                type: HOMEPAGE_DATA_REQUEST_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: HOMEPAGE_DATA_REQUEST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.log(err)
        dispatch({
            type: HOMEPAGE_DATA_REQUEST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

export const getAboutData = (lang) => async (dispatch) => {
    try {
        dispatch({ type: ABOUT_DATA_REQUEST })
        const { data } = await axios.get(`/api/About?lan=${lang}`)
        //console.log(localStorage.getItem("lang"));
        if (data.status === "ok") {
            dispatch({
                type: ABOUT_DATA_REQUEST_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: ABOUT_DATA_REQUEST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: ABOUT_DATA_REQUEST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

export const getContactData = (lang) => async (dispatch) => {
    try {
        dispatch({ type: CONTACT_DATA_REQUEST })
        const { data } = await axios.get(`/api/contactUs?lan=${lang}`)
        //console.log(localStorage.getItem("lang"));
        if (data.status === "ok") {
            dispatch({
                type: CONTACT_DATA_REQUEST_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: CONTACT_DATA_REQUEST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: CONTACT_DATA_REQUEST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

export const sendContactData = (datas) => async (dispatch) => {
    try {
        dispatch({ type: CONTACT_REQUEST })
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }
        const { data } = await axios.post(`/api/sendMessage`, datas, config)
        if (data.status === "ok") {
            dispatch({
                type: CONTACT_REQUEST_SUCCESS,
                payload: 'پیام شما با موفقیت ارسال شد.'
            })
        }
        else {
            dispatch({
                type: CONTACT_REQUEST_FAIL,
                payload: 'خطا در ارسال اطلاعات '
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: CONTACT_REQUEST_FAIL,
            payload: 'خطا در ارسال اطلاعات '

        })
    }
}
